import apiClient from './apiClient'

export const AVITO_AUTOLOAD_PROPERTY_RIGHTS = Object.freeze([
	'Собственник',
	'Посредник',
])

function accountParams(classifiedAccountId) {
	return { classifiedAccountId: String(classifiedAccountId) }
}

export function getAvitoAutoloadErrorMessage(error) {
	const backendError = error?.response?.data?.error
	const code = backendError?.code
	const messages = {
		ACCOUNT_NOT_FOUND: 'Аккаунт Авито не найден или недоступен.',
		ACCOUNT_DISABLED: 'Включите аккаунт Авито, чтобы изменять автозагрузку.',
		AUTOLOAD_VALIDATION_FAILED:
			'Объявление пока нельзя добавить. Исправьте указанные данные.',
		LISTING_CATEGORY_CONFLICT:
			'Категория объекта изменилась и не совпадает с сохранённой категорией объявления.',
		LISTING_NOT_FOUND: 'Объявление уже исключено или недоступно.',
		AUTOLOAD_INPUT_INVALID: 'Проверьте выбранный аккаунт, объект и параметры публикации.',
	}
	return (
		messages[code] ||
		(typeof backendError?.message === 'string'
			? backendError.message
			: 'Не удалось выполнить операцию автозагрузки Авито.')
	)
}

export async function getAvitoAutoload(
	classifiedAccountId,
	client = apiClient
) {
	const response = await client.get('/classifieds/avito/autoload', {
		params: accountParams(classifiedAccountId),
	})
	return response.data
}

export async function listAvitoAutoloadObjects(
	{ classifiedAccountId, search = '', page = 1, pageSize = 20 },
	client = apiClient
) {
	const response = await client.get('/classifieds/avito/autoload/objects', {
		params: {
			...accountParams(classifiedAccountId),
			search,
			page,
			pageSize,
		},
	})
	return response.data
}

export async function previewAvitoAutoloadObject(
	{ objectId, classifiedAccountId, propertyRights },
	client = apiClient
) {
	const response = await client.get(
		`/classifieds/avito/autoload/preview/${objectId}`,
		{
			params: {
				...accountParams(classifiedAccountId),
				propertyRights,
			},
		}
	)
	return response.data
}

export async function includeInAvitoAutoload(payload, client = apiClient) {
	const response = await client.post('/classifieds/avito/autoload', {
		classifiedAccountId: String(payload.classifiedAccountId),
		objectId: String(payload.objectId),
		propertyRights: payload.propertyRights,
	})
	return response.data
}

export async function excludeFromAvitoAutoload(listingId, client = apiClient) {
	const response = await client.patch(
		`/classifieds/avito/autoload/${listingId}`,
		{ desiredState: 'EXCLUDED' }
	)
	return response.data.listing
}

export async function previewAvitoAutoloadFeed(
	classifiedAccountId,
	client = apiClient
) {
	const response = await client.get(
		'/classifieds/avito/autoload/feed-preview',
		{ params: accountParams(classifiedAccountId) }
	)
	return response.data
}

export async function fetchAvitoAutoloadFeed(
	classifiedAccountId,
	client = apiClient
) {
	return client.get('/classifieds/avito/autoload/feed.xml', {
		params: accountParams(classifiedAccountId),
		responseType: 'blob',
	})
}

export function saveAvitoFeedResponse(response, documentRef = document) {
	const disposition = response.headers?.['content-disposition'] || ''
	const match = disposition.match(/filename="([^"]+)"/)
	const filename = match?.[1] || 'reldo-avito-feed.xml'
	const url = URL.createObjectURL(response.data)
	const anchor = documentRef.createElement('a')
	anchor.href = url
	anchor.download = filename
	documentRef.body.appendChild(anchor)
	anchor.click()
	anchor.remove()
	URL.revokeObjectURL(url)
	return filename
}
